import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCaretLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { Button, Skeleton } from '@client/toolkit';

export const BackButton = () => {
  const navigate = useNavigate();
  const { t, ready } = useTranslation('common');

  const handleGoBack = useCallback(() => navigate(-1), [navigate]);

  return (
    <Button color="primary-dark" fontSize="sm" onClick={handleGoBack}>
      <FaCaretLeft className="-ml-2 mr-2 -my-2 text-lg" />
      {ready ? t('back') : <Skeleton variant="text" />}
    </Button>
  );
};
